import { render, staticRenderFns } from "./AddClass.vue?vue&type=template&id=16aff7ca&"
import script from "./AddClass.vue?vue&type=script&lang=ts&"
export * from "./AddClass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports